import { render, staticRenderFns } from "./internalResultTab.vue?vue&type=template&id=0ee37391"
import script from "./internalResultTab.vue?vue&type=script&lang=js"
export * from "./internalResultTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee37391')) {
      api.createRecord('0ee37391', component.options)
    } else {
      api.reload('0ee37391', component.options)
    }
    module.hot.accept("./internalResultTab.vue?vue&type=template&id=0ee37391", function () {
      api.rerender('0ee37391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/temp2/internalResultTab.vue"
export default component.exports